import { FormControl, FormGroup } from '@angular/forms';
import { IDateRangePickerDate } from '../../../../shared/components/date-range-picker/date-range-picker.interface';

export enum ERecursionLimitType {
  never = 'never',
  endDateLimit = 'endDateLimit',
  numberLimit = 'numberLimit',
}

export interface IRecurringItemFormGroup {
  endDateLimit: FormControl<IDateRangePickerDate | null | undefined>;
  numberLimit: FormControl<number | null>;
  cron: FormControl<string | null>;
  selectedLimitType: FormControl<ERecursionLimitType | null>;
}

export interface IRecurrenceConfigurationInjectData {
  formGroup: FormGroup<IRecurringItemFormGroup>;
  mode: 'manage' | 'show';
}
